import script from "./TeacherList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeacherList.vue?vue&type=script&lang=ts&setup=true"

import "./TeacherList.vue?vue&type=style&index=0&id=1efeebba&scoped=true&lang=css"
script.__scopeId = "data-v-1efeebba"

export default script